import styled from 'styled-components';
import {dFlexColumnCenter} from '../../../../globalVariables/GlobalFlex';
import {ellipsisLines} from '../../../../globalVariables/GlobalVariables';

export const header = styled.div`
    ${dFlexColumnCenter};
    flex: none;
    gap: var(--space-xs);
    padding: var(--space-lg) var(--space-lg) 0;
    text-align: center;
`;

/* h2, not h1: every slide of the carousel carries this header, and one page holds several of them */
export const title = styled.h2`
    font-size: var(--font-size-heading-card);
    font-weight: var(--font-weight-semibold);
    line-height: 1.2;
    ${ellipsisLines(2)}
`;

export const subtitle = styled.p`
    font-size: var(--font-size-caption);
    font-weight: var(--font-weight-regular);
    color: var(--color-text-subtle);
    ${ellipsisLines(1)}
`;
